class ProductSection extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("productformvariants:change", (event) => {
      render(event.detail.variant);
    });

    function render(variant) {
      const container = document.querySelector("product-section");

      const section_url = `${location.pathname}/?variant=${variant.id}&section_id=${container.dataset.sectionId}`;

      return fetch(section_url)
        .then((response) => response.text())
        .then((response) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(response, "text/html");

          var section = doc.querySelector("product-section");

          container.replaceWith(section);
        });
    }
  }
}

customElements.define("product-section", ProductSection);